<template>
  <div>
    <preload v-show="cargando" />
    <topBar />
    <v-container fluid fill-height class="pa-0">
      <v-row no-gutters>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col v-if="mostrarMenu" md="auto" class="pa-0">
              <menuBar
                @menu:cargarContenido="cargarContenido"
                :permiso_usuario="permisos"
              />
            </v-col>
            <v-col>
              <!--<v-container fluid fill-height>-->
              <v-row align-left no-gutters>
                <component
                  v-bind:is="contenido"
                  :father="seccion"
                  @menu:cargarContenido="cargarContenido"
                  @reporteGralGrilla:mostrarOcultarPreload="
                    mostrarOcultarPreload
                  "
                  @notasMaterias:mostrarOcultarPreload="mostrarOcultarPreload"
                  @abanderados:mostrarOcultarPreload="mostrarOcultarPreload"
                  @promedios:mostrarOcultarPreload="mostrarOcultarPreload"
                  @notasCriticas:mostrarOcultarPreload="mostrarOcultarPreload"
                  @libreta:mostrarOcultarPreload="mostrarOcultarPreload"
                  @curricula:mostrarOcultarPreload="mostrarOcultarPreload"
                ></component>
              </v-row>
              <!--</v-container>-->
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!--<v-row>
        <v-col md="auto">
          <v-footer fixed md="auto">
            <v-btn
              color="primary"
              dark
              bottom
              left
              fab
              small
              @click="cambiarTema"
            >
              <v-icon>{{
                !this.$vuetify.theme.dark
                  ? "mdi-brightness-7"
                  : "mdi-brightness-4"
              }}</v-icon>
            </v-btn>
          </v-footer>
        </v-col>
      </v-row>-->
    </v-container>
    <!--
    <v-footer fixed>
      <v-btn color="primary" dark bottom left fab small @click="cambiarTema">
        <v-icon>{{ (!this.$vuetify.theme.dark)? 'mdi-brightness-7' : 'mdi-brightness-4' }}</v-icon>
      </v-btn>
    </v-footer>-->
  </div>
</template>

<script>
import API from "@/components/_config/conf";

import topBar from "@/components/main/topBar";
import menuBar from "@/components/main/menu";
import preload from "@/components/main/preload";

/* Componentes Usuarios */
import listarUsuarios from "@/components/usuarios/listarUsuarios";
/* ------------------- */

/* Componentes Alumnos */
import listarAlumnos from "@/components/alumnos/listarAlumnos";
/* ------------------- 

/* Componentes Docentes */
import contenidoDocente from "@/components/docentes/vistaPrincipalDocente";
import listarDocentes from "@/components/docentes/listarDocentes";
/* ------------------- */

/* Componentes Reportes */
import reporteGral from "@/components/reportes/reporteGralGrilla";
import reporteAbanderados from "@/components/reportes/reporteAbanderados";
import reportePromedios from "@/components/reportes/reportePromedios";
import reporteNotasCriticas from "@/components/reportes/reporteNotasCriticas";
import reporteHistorialAlumno from "@/components/reportes/reporteHistorialAlumno";
/* ------------------- */

/* Componentes Administrativo */
import listarMaterias from "@/components/materias/listarMaterias";
import materiasPrevias from "@/components/administrativo/materiasPrevias";
import notasMaterias from "@/components/administrativo/notasMaterias";
import libreta from "@/components/administrativo/libreta";
import promoverAlumnos from "@/components/administrativo/promoverAlumnos"; /*
import analitico from "@/components/administrativo/analitico";
/* ------------------- */

/* Componentes Configuración */
import curricula from "@/components/configuracion/curricula";
import configNotas from "@/components/configuracion/configNotas";
/* ------------------- */

export default {
  data: () => ({
    cargando: false,
    seccion: "",
    contenido: "",
    mostrarMenu: false,
    permisos: [],
  }),
  components: {
    API,
    topBar,
    menuBar,
    preload,
    listarUsuarios,
    listarAlumnos,
    contenidoDocente,
    listarDocentes,
    listarMaterias,
    notasMaterias,
    materiasPrevias,
    libreta,
    promoverAlumnos,
    reporteGral,
    reporteAbanderados,
    reportePromedios,
    reporteNotasCriticas,
    reporteHistorialAlumno,
    /*analitico,*/
    configNotas,
    curricula,
  },
  mounted: function () {
    //console.log(this.$vuetify.theme);
    /*
    let local = window.localStorage.getItem("EPA_AUTH");

    if (local != null) {
      let localJson = JSON.parse(local);
      //let token = localJson.token;
      let categoria = localJson.idCategoria;

      this.nivelPermiso = categoria;

      if (categoria <= 3 || categoria == 7) {
        this.mostrarMenu = true;
        this.contenido = "";
      } else if (categoria == 4) this.contenido = "contenidoDocente";
      else this.contenido = "";
    } else {
      document.location.href = "/login";
    }*/
    this.obtenerPermisos();
  },
  methods: {
    cambiarTema: function () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },
    obtenerPermisos: function () {
      let local = window.localStorage.getItem("EPA_AUTH");

      if (local != null) {
        let localJson = JSON.parse(local);
        this.permisos =
          localJson.permiso != null ? localJson.permiso.split(",") : "";
        let categoria = localJson.categoria;
        if (categoria == "docente") this.contenido = "contenidoDocente";
        else this.mostrarMenu = true;
      }
      console.log("permisos: ", this.nivelPermiso);
    },
    cargarContenido: function (ele, sec) {
      //console.log("cargarContenido--->main", ele, sec, param);
      this.contenido = ele;
      this.seccion = sec;
      //this.mostrarOcultarPreload();
    },
    mostrarOcultarPreload: function (parametro) {
      //console.log("notasMaterias:mostrarOcultarPreload", parametro);
      if (parametro != undefined) this.cargando = parametro;
      else this.cargando = !this.cargando;
    },
  },
};
</script>

<style>
.contenido {
  width: 100% !important;
}

.theme--light.v-footer,
.theme--dark.v-footer {
  background-color: transparent !important;
}
</style>